
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface QuarterlyEvent {
  slug: string;
  quarter: string;
  v1: string;
  v2: string;
  has_changes: boolean;
  plans_changed: boolean;
  price_increased: boolean;
  price_decreased: boolean;
  price_availability_changed: boolean;
  display_changed: boolean;
  intro_discount: boolean;
  changes: string[];
  v1_pi_url?: string;
  v2_pi_url?: string;
  v1_url?: string;
  v2_url?: string;
  type?: string;
}

interface QuarterlyEventsState {
  events: QuarterlyEvent[];
  loading: boolean;
  error: string | null;
}

const initialState: QuarterlyEventsState = {
  events: [],
  loading: false,
  error: null,
};

const quarterlyEventsSlice = createSlice({
  name: 'quarterlyEvents',
  initialState,
  reducers: {
    setQuarterlyEvents: (state, action: PayloadAction<QuarterlyEvent[]>) => {
      state.events = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { setQuarterlyEvents, setLoading, setError } = quarterlyEventsSlice.actions;
export default quarterlyEventsSlice.reducer;
